import { Injectable } from '@angular/core';
import { ActionDisabledCondition, ActionItemOptions, UserAction } from '@mediahaven/shared';
import { ApiFragment, NavigationLink, RecordTypeStructure } from '@stylehaven/components';
import { Observable, of } from 'rxjs';
import { MediaHavenActionType } from '../../../entities/action-types.entity';
import { ActionLinkService } from '../../abstract/action-link.service.interface';

@Injectable({ providedIn: 'root' })
export class OpenDetailActionService extends ActionLinkService {
    protected action: MediaHavenActionType = MediaHavenActionType.WATCH;

    /*  Watch
     *  Available when:
     *   * item is NOT deleted
     *   * Item is NOT a representation
     *
     *  Disabled when:
     *   * Never
     */
    public getUserAction(record: ApiFragment): Observable<UserAction> {
        return of(this.userActionBuilder(record));
    }

    public override userActionBuilder(record: ApiFragment): UserAction {
        const isDeleted: boolean = record.isDeleted();
        const isRepresentation: boolean = record.getRecordStructure() === RecordTypeStructure.Representation;

        const availableConditions: boolean[] = [!isDeleted, !isRepresentation];
        const disableConditions: ActionDisabledCondition[] = [];

        return new UserAction(availableConditions, disableConditions);
    }

    public getLabelKey(target: ApiFragment): string {
        return 'actions.view-metadata';
    }

    protected getLink(record: ApiFragment, actionItemOptions: ActionItemOptions): Observable<NavigationLink> {
        const route = actionItemOptions.shareContext
            ? record.getShareDetailUrl(actionItemOptions.shareContext)
            : record.getDetailUrl();

        const state: any = {
            queryIteratorStack: actionItemOptions.queryIteratorStack
        };

        return of({
            route,
            extras: { state }
        });
    }
}
